/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

/**
 * Timeout Error.
 */
export class TimeoutError extends Error {
  /**
   * constructor.
   * @param {string} msg
   */
  constructor(msg: string) {
    super(msg);
    this.name = new.target.name;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
